module.exports = __webpack_public_path__ + "static/img/computed.e785ded8.png";